import { IBidRateCoachGrades, IShipmentOptionGrade, Maybe } from 'types/graphqlTypes'

export const getGaugeColour = (score?: Maybe<IBidRateCoachGrades>) => {
  switch (score) {
    case IBidRateCoachGrades.poor:
      return '#BD1A1D'
    case IBidRateCoachGrades.fair:
      return '#D76106'
    case IBidRateCoachGrades.good:
      return '#226342'
    default:
      return '#D3D9E0'
  }
}

export const getGaugeOffset = (score?: Maybe<IBidRateCoachGrades>) => {
  switch (score) {
    case IBidRateCoachGrades.poor:
      return 20
    case IBidRateCoachGrades.fair:
      return 50
    case IBidRateCoachGrades.good:
      return 90
    default:
      return 0
  }
}

export const getScoreCopy = (score?: Maybe<IBidRateCoachGrades>) => {
  switch (score) {
    case IBidRateCoachGrades.poor:
      return 'Keep negotiating or send for approval.'
    case IBidRateCoachGrades.fair:
      return 'Keep negotiating or send for approval.'
    case IBidRateCoachGrades.good:
      return 'This is a good option. Proceed with this option. No approval required.'
    default:
      return 'Enter a rate to see negotiation coach'
  }
}

export const calculateRateCoachGrade = ({
  optionGradeTiers,
  rate,
}: {
  optionGradeTiers?: Maybe<IShipmentOptionGrade>
  rate?: Maybe<number>
}): Maybe<IBidRateCoachGrades> => {
  if (!(optionGradeTiers && rate)) {
    return null
  }
  const { maxFairBidAmount, maxGoodBidAmount } = optionGradeTiers
  if (rate <= maxGoodBidAmount) {
    return IBidRateCoachGrades.good
  }
  if (rate <= maxFairBidAmount) {
    return IBidRateCoachGrades.fair
  }
  return IBidRateCoachGrades.poor
}
